module.exports = __webpack_public_path__ + "static/media/mdwa.faab8634.woff";